// extracted by mini-css-extract-plugin
export default {"container":"tutorLessons_container__fXTKd","isOpen":"tutorLessons_isOpen__w3HET","title":"tutorLessons_title__qeke4","content":"tutorLessons_content__dKycL"};